import React from 'react';
import { useNavigate } from 'react-router-dom';

const InterviewCompleted = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-3xl font-light mb-6">Interview Completed</h1>
        <p className="text-gray-600 mb-8">
          This interview round has already been completed. Thank you for your participation.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
        >
          Return Home
        </button>
      </div>
    </div>
  );
};

export default InterviewCompleted; 